import React from 'react'

import { StatusBadge } from '@driftt/dds'

import { bucketFitScore } from './utils'

const AccountFitScore = ({ score }: { score: number | undefined }) => {
  const bucketedScore = bucketFitScore(score)
  let fitStyle: 'inactive' | 'error' | 'warning' | 'success' | 'pending'
  switch (bucketedScore) {
    case 'Unknown':
      fitStyle = 'inactive'
      break
    case 'Poor':
      fitStyle = 'error'
      break
    case 'Fair':
      fitStyle = 'warning'
      break
    default:
      fitStyle = 'success'
  }

  return (
    <StatusBadge variant={fitStyle} size="medium">
      {bucketedScore}
    </StatusBadge>
  )
}

export default AccountFitScore
